<template>
  <ModalDraggable :active="true" classs="w-full h-full share-library-ob">
    <template #default>
      <div class="bg-light-100 relative flex h-full w-full items-center justify-center">
        <div
          class="hover:bg-light-300 absolute !top-8 !right-8 flex !h-10 !w-10 cursor-pointer items-center justify-center rounded-[3px]"
          @click="close">
          <img class="!h-5 !w-5" src="../../assets/images/close_icon.svg" />
        </div>
        <div class="mr-[61px]">
          <div class="text-light-mode-low-contrast text-sm font-medium !leading-4">SHARE LIBRARY</div>
          <div
            class="text-light-mode-high-contrast !mt-3 h-[114px] max-w-[425px] text-[32px] font-semibold leading-[38.4px]">
            Transfer templates or blocks between multiple Shopify stores
          </div>
          <div class="text-light-mode-low-contrast !mt-4 max-w-[399px] text-sm font-normal leading-[22px]">
            Allows you to transfer the designed templates from one store to another which helps you to save time for
            building and redesigning your pages.
          </div>
          <ButtonBase class="!mt-6 h-[40px] w-[284px]" @click="openPricingPage">
            <span class="text-light-100 text-sm font-medium leading-[21px]">Upgrade your plan</span>
          </ButtonBase>
          <div class="text-light-mode-high-contrast mt-[68px] text-base font-medium leading-[20px]">
            Save time for building your pages
          </div>
          <div class="text-light-mode-low-contrast !mt-2 max-w-[399px] text-sm font-normal leading-[22px]">
            Sticky "Add to Cart" makes the purchase easier than before as it constantly shows on every product pages to
            boost your conversions.
          </div>
        </div>
        <div>
          <img class="mt-[28px] h-[267px] w-[576px]" src="../../assets/images/share_library_ob_image.png" />
          <div class="text-light-mode-high-contrast mt-[63px] !pl-5 text-base font-medium leading-[20px]">
            Start with ease
          </div>
          <div class="text-light-mode-low-contrast !mt-2 max-w-[399px] !pl-5 text-sm font-normal leading-[22px]">
            Sticky Add to Cart bar allows customers to quickly add products to cart and reach checkout faster with just
            one click on the button.
          </div>
        </div>
      </div>
    </template>
  </ModalDraggable>
</template>

<script setup lang="ts">
import { ButtonBase } from '@modules/common';
import { useStore } from 'vuex';
import ModalDraggable from '@/core/components/ModalDraggable.vue';
import { MODULE_NAME } from '../../constants';
import { mutations } from '../../store/types';
import { useGoToPricing } from '@/modules/editor-sidebar/hooks/useGoToPricing';
const store = useStore();
const { goToPricing } = useGoToPricing();
const close = () => {
  store.commit(`${MODULE_NAME}/${mutations.UPDATE_SHOW_SHARE_LIBRARY_ON_BOARDING}`, false);
};
const openPricingPage = () => {
  //TRUONGNC-LINK HERE
  close();
  goToPricing();
};
</script>
<style scoped lang="scss">
.share-library-ob {
  .dragmodal_container {
    height: 100vh !important;
  }
}
</style>
